// extracted by mini-css-extract-plugin
export default {"overlay":"rgba(51, 51, 51, .5)"};